// These paths are also protected before the application bundle loads and by the
// service worker. Keep their contracts covered together by the privacy tests.
export function isCredentialPagePath(path) {
  if (typeof path !== 'string') return false
  try { path = decodeURIComponent(path).replace(/^\/+/, '/') } catch { return true }
  return /^\/(?:login|role|register(?:final(?:-legacy)?)?|forgot-password|reset-password|verify-email|email-change|verify\/email|email|send\/email)(?:\/|$)/i.test(path)
}

export function parseCredentialToken(hash, kind = 'account') {
  if (typeof hash !== 'string' || !hash.startsWith('#') || hash.length > 270) return null
  // Vue Router already decodes route.hash. Never decode it a second time.
  const token = hash.slice(1)
  if (kind === 'emailChange') return /^[a-f0-9]{64}(?![\s\S])/.test(token) ? token : null
  if (kind !== 'account' || !/^[A-Za-z0-9+/]{86}==(?![\s\S])/.test(token)) return null
  try {
    const raw = atob(token)
    return /^[A-Za-z0-9]{64}(?![\s\S])/.test(raw) && btoa(raw) === token ? token : null
  } catch { return null }
}

export function legacyCredentialRedirect(to, name) {
  const token = typeof to.params?.token === 'string' ? parseCredentialToken(`#${to.params.token}`) : null
  return { name, hash: token ? `#${token}` : '', replace: true }
}

export function clearCredentialLinkUrl(route, router) {
  if (typeof window === 'undefined' || !route || typeof route.fullPath !== 'string') return false
  const visiblePath = window.location.pathname + window.location.search + window.location.hash
  if (!route.hash || !isCredentialPagePath(route.path)) return false
  const hashIndex = route.fullPath.indexOf('#')
  if (hashIndex < 0) return false
  const encodedHash = route.fullPath.slice(hashIndex)
  let decodedHash = encodedHash
  try { decodedHash = decodeURIComponent(encodedHash) } catch { /* Invalid links still need cleanup. */ }
  if (decodedHash !== route.hash && encodedHash !== route.hash) return false
  const isVisibleRoute = visiblePath === route.fullPath
  const cleanPath = route.fullPath.slice(0, hashIndex)
  try {
    const state = window.history.state
    const cleanState = state && typeof state === 'object' ? { ...state } : state
    if (cleanState) {
      for (const key of ['current', 'back', 'forward']) {
        if (cleanState[key] === route.fullPath) cleanState[key] = cleanPath
      }
    }
    window.history.replaceState(cleanState, '', isVisibleRoute ? cleanPath : visiblePath)
    // Keep Vue Router in sync so its next push cannot restore the proof in the
    // previous history entry. Callers retain the captured proof only in memory.
    if (isVisibleRoute && router?.currentRoute?.value?.fullPath === route.fullPath) {
      return router.replace({ path: route.path, query: router.currentRoute.value.query, hash: '' })
        .then(() => true).catch(() => false)
    }
    return true
  } catch { return false }
}
